/* Project Start */

/* Multimove */
export const appLoadProgess = (data) => ({
    type: "APP_LOAD_PROGRESS",
    data
})


/* Transform Manager*/
export const moveUpdate = (data, socket) => ({
    type: "MOVE_UPDATE",
    data, socket
})

export const moveUpdateComplete = (selectedScene, workspaceItems, workspaceChildren, currentContainer,socketId, currentSocketId) => ({
    type: "MOVE_UPDATE_COMPLETE",
    selectedScene, workspaceItems, workspaceChildren,currentContainer, socketId, currentSocketId
})



export const changelibBG = (data) => ({
    type: "CHANGE_LIB_BG",
    data
})

export const deleteBG = (data, socket) => ({
    type: "DELETE_BG",
    data, socket
})

export const dropBG = (data, deleteData, socket) => ({
    type: "DROP_BG",
    data, deleteData, socket
})


export const resizeUpdate = (data, socket) => ({
    type: "RESIZE_UPDATE",
    data, socket
})

export const rotationUpdate = (data, socket) => ({
    type: "ROTATION_UPDATE",
    data, socket
})

export const setSelectedItems = (data, socket) => ({
    type: "SET_SELECTED_ITEMS",
    data, socket
})

export const changeVideoVolumeComplete = (selectedScene, objectId, objectData, socketId, currentSocketId) => ({
    type: 'CHANGE_VIDEO_VOLUME_COMPLETE',
    selectedScene, objectId, socketId, currentSocketId
})

/* Text*/

export const changeText = (data, socket) => ({
    type: "CHANGE_TEXT",
    data,
    socket
})

export const changeTextComplete = (selectedScene, currentContainer,itemId, objectData, socketId, currentSocketId, selfUpdate) => ({
    type: "CHANGE_TEXT_COMPLETE", selectedScene, currentContainer, itemId, objectData, socketId, currentSocketId, selfUpdate
})

export const updateText = (data, socket) => ({
    type: "UPDATE_TEXT",
    data, socket
})

export const updateTextStatus = (data) => ({
    type: "UPDATE_TEXT_STATUS",
    data
})

export const setTextOptions = (data) => ({
    type: "SET_TEXT_OPTIONS",
    data
})

export const updateGroupText = (data, socket) => ({
    type: "UPDATE_GROUP_TEXT",
    data, socket
})

/* Project Initiation */

export const initateProject = (data) => ({
    type: "INITIATE_PROJECT",
    data
})

export const loadSceneThumbnails = (data) => ({
    type: "LOAD_SCENE_THUMBNAILS",
    data
})


/* Project End */

/* Library Start */

export const setSearchData = (data) => ({
    type: "SET_SEARCH_DATA",
    data
})

/* Library End */


export const toggleCrop = () => ({
    type: "TOGGLE_CROP"
})

export const toggleBgCrop = () => ({
    type: "TOGGLE_BG_CROP"
})

export const toggleFrame = () => ({
    type: "TOGGLE_FRAME"
})

export const cropImage = (data, socket) => ({
    type: 'CROP_IMAGE',
    data, socket
})

export const cropImageComplete = (selectedScene, itemId, objectData, socketId, currentSocketId) => ({
    type: 'CROP_IMAGE_COMPLETE',
    selectedScene, itemId, objectData, socketId, currentSocketId
})

export const cropBG = (data, socket) => ({
    type: 'CROP_BG',
    data, socket
})

export const cropBgComplete = (selectedScene, objectData, isVideo, videoId, bgScales, socketId, currentSocketId) => ({
    type: 'CROP_BG_COMPLETE',
    selectedScene, objectData, isVideo, videoId, bgScales, socketId, currentSocketId
})

export const toggleVideoCrop = (id) => ({
    type: 'TOGGLE_VIDEO_CROP',
    id
})

export const updateTransformStatus = (data) => ({
    type: "UPDATE_TRANSFORM_STATUS",
    data
})

export const showLibrary = (data) => ({
    type: "SHOW_LIBRARY",
    data
})

export const startPlay = (data, source, playHead) => ({
    type: "START_PLAY",
    data,
    source, playHead
})

export const addTween = (data, tweenType) => ({
    type: "ADD_TWEEN",
    data,
    tweenType
})

export const updateSVGColor = (socket,id,cls,color,selectedScene, container) => ({
    type: 'UPDATE_SVGCOLOR',
    socket,id,cls,color,selectedScene, container
})

export const updateBGColor = (socket,cls,color,selectedScene, container) => ({
    type: 'UPDATE_BGCOLOR',
    socket,cls,color,selectedScene, container
})

export const updateBGGradient = (socket, cls, color, selectedScene, container) => ({
    type: 'UPDATE_BGGRADIENT',
    socket, cls, color, selectedScene, container
})

export const updateBgColorComplete = (selectedScene, Cls, color, socketid, currentSocketId) => ({
    type: 'UPDATE_BGCOLOR_COMPLETE',
    selectedScene, Cls, color, socketid, currentSocketId
})

export const updateBgGradientComplete = (selectedScene, gradientIndex, gradientSecIndex, color, socketid, currentSocketId) => ({
    type: 'UPDATE_BGGRADIENT_COMPLETE',
    selectedScene, gradientIndex, gradientSecIndex, color, socketid, currentSocketId
})

export const updateSVGTheme = (socket,id,colorData,selectedScene, container, isBG) => ({
    type: 'UPDATE_SVG_THEME',
    socket,id,colorData,selectedScene, container, isBG
})

export const changePlayTime = (data) => ({
    type: "CHANGE_PLAYTIME",
    data
})

export const flipItem = (data, socket) => ({
    type: "FLIP_ITEM",
    data, socket
})


export const flipItemComplete = (selectedScene, itemId, flipPosition, socketId, currentSocketId) => ({
    type: 'FLIP_ITEM_COMPLETE',
    selectedScene, itemId, flipPosition, socketId, currentSocketId
})

export const deleteItem = (data, socket) => ({
    type: 'DELETE_ITEM',
    data, socket
})

export const deleteItemComplete = (selectedScene, workspaceIds, workspaceChildrenIds, indexChangeIds, socketId, currentSocketId) => ({
    type: 'DELETE_ITEM_COMPLETE',
    selectedScene, workspaceIds, workspaceChildrenIds, indexChangeIds, socketId, currentSocketId
})

/* Timeline */

export const onItemDrag = (socket, item, data, id, selItem, selectedScene, category) => ({
    type: 'UPDATE_TIMELINE_DRAG',
    socket,
    item,
    data,
    id,
    selItem,
    selectedScene,
    category
})

export const applyEnterEffect=(data,socket)=>({
    type:'APPLY_ENTER_EFFECT',
    data,socket
})

export const applyEnterEffectComplete=(projectid,selectedScene,effectData,isUndo,sceneEffectData,socketId,currentSocketId)=>({
    type:'APPLY_ENTER_EFFECT_COMPLETE',
    projectid,selectedScene,effectData,isUndo,sceneEffectData,socketId,currentSocketId
})

export const updateTimelineDragChangeComplete = (selectedScene, itemData, actionData, idVal, childToUpdate, socketId, currentSocketId) => ({
    type: 'UPDATE_TIMELINE_DRAG_COMPLETE',
    selectedScene, itemData, actionData, idVal, childToUpdate, socketId, currentSocketId
})

export const changeObjectThumb = (timeName, socket, time, id, selectedScene, index) => ({
    type: timeName, 
    socket,
    time,
    id,
    selectedScene,
    index
})

export const deleteObject = (type, socket,id, selectedScene, selectedItem) => ({
    type: type,
    socket: socket,
    id: id,
    selectedScene: selectedScene,
    selectedItem: selectedItem
})

export const updateVolume = (type, value, id, selectedScene, selectedItem, socket) => ({
    type: type,
    value: value,
    id: id,
    selectedScene,
    selectedItem,
    socket
})

export const setWorkspaceTextFocus = (value) => ({
    type: 'SET_WORKSPACE_TEXT_FOCUS',
    value
})

export const addUploadItem = (data) => ({
    type: 'ADD_UPLOAD_ITEM',
    data
})

/* Slides */
export const addScene = (data,socket) => ({
    type: 'ADD_SCENE',
    data, socket
})

export const dropNewScene = (data) => ({
    type: 'DROP_NEW_SCENE',
    data
})

export const addSceneComplete = (slideIndex, newslide, socketId, currentSocketId) => ({
    type: 'ADD_SCENE_COMPLETE',
    slideIndex, newslide, socketId, currentSocketId
})

export const duplicateSceneComplete = (slideIndex, newslide, socketId, currentSocketId) => ({
    type: 'DUPLICATE_SCENE_COMPLETE',
    slideIndex, newslide, socketId, currentSocketId
})

export const setSelectedScene = (data, time, selectedScenes, socket) => ({
    type: 'SET_SELECTED_SCENE',
    data, time, selectedScenes, socket
})

export const moveScene = (newIndex, oldIndex, socket) => ({
    type: 'MOVE_SCENE',
    newIndex,
    oldIndex,
    socket
})

export const moveSceneComplete = (projectId, newIndex, oldIndex, socketId, currentSocketId) => ({
    type: 'MOVE_SCENE_COMPLETE',
    projectId,
    newIndex,
    oldIndex,
    socketId, currentSocketId
})

export const removeScene = (data, socket) => ({
    type: 'REMOVE_SCENE',
    data, socket
})

export const removeSceneComplete = (slideIndex, socketId, currentSocketId) => ({
    type: 'REMOVE_SCENE_COMPLETE',
    slideIndex, socketId, currentSocketId
})

export const addSceneTransitionComplete = (slideIndex,transitionName, sizes, socketId, currentSocketId) => ({
    type: 'ADD_SCENE_TRANSITION_COMPLETE',
    slideIndex,transitionName, sizes, socketId, currentSocketId
})
export const changeSceneTransColorComplete = (selectedScene,color,socketId, currentSocketId) => ({
    type: 'ADD_SCENE_TRANSITION_COLOR_COMPLETE',
    selectedScene,color,socketId, currentSocketId
})
 
export const changeExpressionComplete = (selectedIndex, itemId, itemLabel, socketId, currentSocketId) => ({
    type: 'CHANGE_EXPRESSION_COMPLETE',
    selectedIndex, itemId, itemLabel, socketId, currentSocketId
})

export const changeActionComplete = (selectedIndex, itemId, itemLabel, socketId, currentSocketId) => ({
    type: 'CHANGE_ACTION_COMPLETE',
    selectedIndex, itemId, itemLabel, socketId, currentSocketId
})

export const deleteBgComplete = (selectedScene, socketId, currentSocketId) => ({
    type: 'DELETE_BG_COMPLETE',
    selectedScene, socketId, currentSocketId
})

export const showSlides = (showPosition) => ({
    type    : 'SHOW_SLIDE_PANEL',
    data    : showPosition
})

export const addObj = (data, socket) => ({
    type: 'ADD_OBJECT',
    data, socket
})

export const upAddObj = (data, socket) => ({
    type: 'UP_ADD_OBJECT',
    data, socket
})

export const changeAnimationType = (selectedScene, itemId, value, socket) => ({
    type: 'CHANGE_ANIMATION_TYPE',
    selectedScene, itemId, value, socket
})

export const changeAnimationTypeComplete = (selectedScene, itemId, value, socketId, currentSocketId) =>({
    type : "CHANGE_ANIMATION_TYPE_COMPLETE",
    selectedScene, itemId, value, socketId, currentSocketId
})

export const addObjComplete = (selectedScene, workspaceIds, workspaceData, workspaceChildrenIds, workspaceChildData, socketId, currentSocketId) => ({
    type: 'ADD_OBJECT_COMPLETE',
    selectedScene, workspaceIds, workspaceData, workspaceChildrenIds, workspaceChildData, socketId, currentSocketId
})

export const changeBgComplete = (selectedScene, workspaceBG, deleteId, deleteData,socketId, currentSocketId) => ({ 
    type: 'DROP_BG_COMPLETE',
    selectedScene, workspaceBG, deleteId, deleteData, socketId, currentSocketId
})

export const duplicateScene = (data, socket) => ({
    type: 'DUPLICATE_SCENE',
    data, socket
})

export const setZoom = (data) => ({
    type: 'SET_ZOOM',
    data
})

export const setPlay = (data,selectedScene) => ({
    type: 'SET_PLAY',
    data,
    selectedScene
})


export const setPlayAll = (data, fromStart  ) => ({
    type: 'SET_PLAY_ALL',
    data,
    fromStart 
})

export const setZIndex = (data, socket) => ({
    type: 'SET_Z_INDEX',
    data, socket
})

export const setZIndexComplete = (selectedScene, indexChangeIds, socketId, currentSocketId) => ({
    type: 'SET_Z_INDEX_COMPLETE',
    selectedScene, indexChangeIds, socketId, currentSocketId
})

export const changeBg = (data, socket) => ({
    type: 'CHANGE_BG',
    data, socket
})

export const toggleGrid = (data) => ({
    type: 'TOGGLE_GRID',
    data
})

export const swapItem = (data) => ({
    type: 'SWAP_ITEM',
    data
})
export const swapItemUndo = (data) => ({
    type: 'SWAP_ITEM_UNDO',
    data
})
export const setCopyItemType = (data) => ({
    type: 'COPY_ITEM_TYPE',
    data
})

export const copyObjects = (value) => ({
    type: 'COPY_OBJECTS',
    value
})

export const cutObjects = (value) => ({
    type: 'CUT_OBJECTS',
    value
})

export const pasteObjects = (value) => ({
    type: 'PASTE_OBJECTS',
    value
})

export const pasteItems = (data, socket) => ({
    type: 'PASTE_ITEMS',
    data, socket
})

export const pasteItemsComplete = (selectedScene, workspaceIds, workspaceChildrenIds, workspaceData, workspaceChildData, socketId, currentSocketId, socket) => ({
    type: 'PASTE_ITEMS_COMPLETE',
    selectedScene, workspaceIds, workspaceChildrenIds, workspaceData, workspaceChildData, socketId, currentSocketId, socket
})


export const groupObjects = (data, socket) => ({
    type: 'GROUP_OBJECTS',
    data, socket
})

export const groupObjectsComplete = (selectedScene, removeIds, workspaceItems, workspaceChildren,workspaceItemsOrder, socketId, currentSocketId) => ({
    type: 'GROUP_OBJECTS_COMPLETE',
    selectedScene, removeIds, workspaceItems, workspaceChildren,workspaceItemsOrder,socketId, currentSocketId
})

export const unGroupObjects = (data, socket) => ({
    type: 'UNGROUP_OBJECTS',
    data, socket
})

export const ungroupObjectsComplete = (selectedScene, removeIds, workspaceChildren,workspaceItemsOrder, socketId, currentSocketId) => ({
    type: 'UNGROUP_OBJECTS_COMPLETE',
    selectedScene, removeIds, workspaceChildren,workspaceItemsOrder, socketId, currentSocketId
})

export const setPropertyWindow = (data) => ({
    
    type: 'SET_PROPERTY_WINDOW',
    data
})

export const addSceneTransition = (data, sizes, slideIndex, socket) => ({
    type: 'ADD_SCENE_TRANSITION',
    data,
    sizes,
    slideIndex, socket
})
export const changeAction = (label,id,selectedScene, socket) => ({
    type: 'CHANGE_ACTION',
    label,
    id,
    selectedScene,
    socket
})

export const changeExpression = (label,id,selectedScene, socket) => ({
    type: 'CHANGE_EXPRESSION',
    label,id,selectedScene, socket
})

export const changeBGThumbValue = (type, value, thumbPosition, selectedScene, socket)=>({
    type : type,
    value : value,
    thumbPosition : thumbPosition,
    selectedScene : selectedScene,
    socket
}) 
export const bgColorSelection = (socket, value, selectedScene, enteredColorPosition, deletePosition, animakerType)=>({
    type:'BG_COLOR_SELECTION',
    socket,
    value:value,
    selectedScene       :   selectedScene,
    enteredColorPosition:   enteredColorPosition,
    deletePosition      :   deletePosition,
    animakerType        :   animakerType
})

export const bgColorSelectionComplete = (selectedScene, objectData, socketId, currentSocketId)=>({
    type:'BG_COLOR_SELECTION_COMPLETE', selectedScene, objectData, socketId, currentSocketId
})

export const applyFilter = (active,filterCode, selectedScene, socket) => ({
    type: 'APPLY_FILTER',
    active,filterCode,selectedScene, socket
})

export const applyFilterComplete = (selectedScene, objectId, objectData, socketId, currentSocketId) => ({
    type: 'APPLY_FILTER_COMPLETE',
    selectedScene, objectId, objectData, socketId, currentSocketId
})

export const copyFilter = (data,subtype) => ({
    type: 'COPY_FILTER',
    data, subtype
})

export const bgGradientSetting = (value, selectedScene, radialStatus,radius,socket) => ({
    type            :   'BG_GRADIENT_COLORS',
    value           :   value,
    selectedScene   :   selectedScene,
    radialStatus    :   radialStatus,
    radius          :   radius,
    socket
})

export const bgGradientColorsComplete = (selectedScene, radialStatus, direction, radius , socketId) => ({
    type            :   'BG_GRADIENT_COLORS_COMPLETE',selectedScene, radialStatus, direction, radius , socketId
})

export const resizeProject = (data) => ({
    type: "RESIZE_PROJECT",
    data
})

export const isUploadFromOutside = (data) => ({
    type: 'FROM_OUTSIDE_UPLOAD',
    data
})

export const loadCommonPopup = (value, status=null) =>({
    type: "DISPLAY_COMMON_POPUP",
    value:value,
    status:status
})

export const updateSvgColorComplete = (selectedScene, container, itemId, itemCls, colorData, socketId, currentSocketId) =>({
    type: "UPDATE_SVGCOLOR_COMPLETE",
    selectedScene, container, itemId, itemCls, colorData, socketId, currentSocketId
})

export const updateSvgThemeComplete = (projectid, selectedScene, container, itemId, colorData, isBG, socketId, currentSocketId) =>({
    type: "UPDATE_SVGTHEME_COMPLETE",
    projectid, selectedScene, container, itemId, colorData, isBG, socketId, currentSocketId
})

export const updateObject = (data, socket) => ({
    type: "UPDATE_OBJECT",
    data,
    socket
})

export const writeText = (data, socket) => ({
    type: "WRITE_TEXT",
    data,
    socket
})

export const syncText = (data) => ({
    type: "SYNC_TEXT",
    data
})

export const updateObjectComplete = (projectid, selectedScene, selectedItem, container, toUpdate, socketId, currentSocketId) => ({
    type: "UPDATE_OBJECT_COMPLETE",
    projectid, selectedScene, selectedItem, container, toUpdate, socketId, currentSocketId
})

export const setUserFonts = (data) => ({
    type: "SET_USER_FONTS",
    data
})

export const setShareDetails = (data) => ({
    type: "SET_SHARE_DETAILS",
    data
})

export const fontUploaded = (data) => ({
    type: "FONT_UPLOADED",
    data
})

export const updateRecentColors = (data) => ({
    type: "UPDATE_RECENT_COLORS",
    data
})

export const updateObjectById = (data, socket) => ({
    type: "UPDATE_OBJECT_BY_ID",
    data,
    socket
})


export const setSelectedKey = (id, time, selectedScene, selectedId, selectedItem) => ({
    type: 'SET_SELECTED_KEYFRAME',
    id, time, selectedScene, selectedId, selectedItem
})




export const updateTextComplete = (isGrouped, selectedScene, selectedId, container, formats, childIds, socketId, currentSocketId, selfUpdate) => ({
    type: "UPDATE_TEXT_COMPLETE",
    isGrouped, selectedScene, selectedId, container, formats, childIds, socketId, currentSocketId, selfUpdate
})

export const updateGroupTextComplete = (selectedScene, workspaceItems, workspaceChildren, socketId, currentSocketId, selfUpdate) => ({
    type: "UPDATE_GROUP_TEXT_COMPLETE",
    selectedScene, workspaceItems, workspaceChildren, socketId, currentSocketId, selfUpdate
})

export const setPrebuiltLoad = (data, source) => ({
    type: 'SET_PREBUILT_LOAD',
    data,
    source
})

export const addPrebuilt = (data, socket) => ({
    type: 'ADD_PREBUILT',
    data,
    socket
})

export const addPrebuiltComplete = (selectedScene, prebuiltData, replace, addAll, socketId, currentSocketId) => ({
    type: 'ADD_PREBUILT_COMPLETE',
    selectedScene, prebuiltData, replace, addAll, socketId, currentSocketId
})

export const toggleToolBar = (data) => ({
    type: 'TOGGLE_TOOLBAR',
    data
})

export const addBulkObjects = (data) => ({
    type: 'ADD_BULK_OBJECTS',
    data
})

export const uploadBulkUpdate = (data, socket) => ({
    type: 'UPLOAD_BULK_UPDATE',
    data, socket
})

export const uploadBulkUpdateComplete = (data) => ({
    type: 'UPLOAD_BULK_UPDATE_COMPLETE',
    data
})

export const uploadBulkDelete = (data, socket) => ({
    type: 'UPLOAD_BULK_DELETE',
    data, socket
})

export const uploadBulkDeleteComplete = (data) => ({
    type: 'UPLOAD_BULK_DELETE_COMPLETE',
    data
})

export const undoMove = (data) => ({
    type: 'UNDO_MOVE',
    data
})

export const updateTextFormats = (data) => ({
    type: 'UPDATE_TEXT_FORMATS',
    data
})

export const updateSlide = (data) => ({
    type: 'UPDATE_SLIDE',
    data
})


export const setSelectedItemsComplete = (projectid, selectedItems, projectUsr,userId,projectUsrImg, socketid, currentSocketId) => ({
    type: 'SET_SELECTED_ITEMS_COMPLETE',
    projectid, selectedItems, projectUsr,userId,projectUsrImg, socketid, currentSocketId
})

export const setSelectedSceneComplete = (projectid, selectedItems, projectUsr,userId,projectUsrImg, socketid, currentSocketId) => ({
    type: 'SET_SELECTED_SCENE_COMPLETE',
    projectid, selectedItems, projectUsr, userId,projectUsrImg,socketid, currentSocketId
})

export const pasteScenesComplete = (selectedScene, scenes, socketId, currentSocketId, socket) => ({
    type: 'PASTE_SCENES_COMPLETE',
    selectedScene, scenes, socketId, currentSocketId, socket
})

export const swapWorkspaceItems = (data) => ({
    type: 'SWAP_WORKSPACE_ITEMS',
    data
})
export const organiseScenes = (data) => ({
    type: 'ORGANISE_SCENES',
    data
})

export const continueScene = (index) => ({
    type: 'CONTINUE_SCENE',
    index
})

export const saveScreenshot = (index, scene, project, userId, projectId, sceneId, isExceeded, screenshots) => ({
    type: 'SAVE_SCREENSHOT',
    index, scene, project, userId, projectId, sceneId, isExceeded, screenshots
})

export const updateSceneComplete = (projectid, selectedScene, toUpdate, toEmit, socketId, currentSocketId) => ({
    type: 'UPDATE_SCENE_COMPLETE',
    projectid, selectedScene, toUpdate, toEmit, socketId, currentSocketId
})

export const updateScene = (data, socket) => ({type : "UPDATE_SCENE", data, socket})

export const updateBgComplete = (projectid, selectedScene, toUpdate, socketId) => ({
    type: 'UPDATE_BG_COMPLETE',
    projectid, selectedScene, toUpdate, socketId
})

export const updateProjectComplete = (projectid, toUpdate, socketId, currentSocketId) => ({
    type: 'UPDATE_PROJECT_COMPLETE',
    projectid, toUpdate, socketId, currentSocketId
})

export const saveProjectName = (data, socket) => ({
    type: 'SAVE_PROJECT_NAME',
    data, socket
})


export const setFullTab = (data) =>({
    type : 'SET_FULL_TAB',
    data
})

export const updateSelectionBox = (data) =>({
    type : "UPDATE_SELECTION_BOX",
    data
})

export const socketConnected = (projectId, userId, selectedItems, imageUrl, projectUsr,socketId, currentSocketId) =>({
    type : "SOCKET_CONNECTED",
    projectId, userId, selectedItems, imageUrl, projectUsr, socketId, currentSocketId
})

export const socketDisconnected = (data) =>({
    type : "SOCKET_DISCONNECTED",
    data
})

export const  openLibrarySection = (data) => ({
    type : "OPEN_LIBRARY_SECTION_TOOGLE",
    data
})

export const  setCurrentPosition = (data) => ({
    type : "SET_CURRENT_POSITION",
    data
})

export const  newSocketConnected = (data) => ({
    type : "NEW_SOCKET_CONNECTED",
    data
})

export const setTextFocus = (value) => ({
    type: 'SET_TEXT_FOCUS',
    value
})


export const changeVideoVolume = (data, socket) =>({
    type: "CHANGE_VIDEO_VOLUME",
    data, socket
})

export const manageToast = (data) =>({
    type: "MANAGE_TOAST",
    data
})


export const setFullScreen =(data) => ({
    type: 'SET_FULSCREEN',
    data
})


export const loadLibrary = (libData) => ({ type: "LOAD_LIBRARY", libData: libData })

export const loadLibraryUpload = (libData) => ({ type: "LOAD_LIBRARY_UPLOAD", libData: libData })

export const loadCategory = (libData) => ({ type: "LOAD_LIBRARY_CATEGORY", libData: libData })

export const deleteUserContent = (id, userId) => ({ type: "DELETE_FILE", id, userId })

export const loadsubFolders = (libData)  => ({ type: "LOAD_USER_FOLDERS", libData: libData})

export const moveToFolder = (libData) => ({ type: "MOVE_FILE_LOCATION", libData })

export const renameUserUpload = (libData) => ({ type: "RENAME_USER_FILE", libData })

export const getSearchData = (libData) => ({ type: "FETCH_SEARCH", libData })

export const getStockSearchData = (libData) => ({ type: "FETCH_STOCK_SEARCH", libData })

export const loadMasterData = (libData) => ({ type: "LOAD_LIBRARY_MASTER", libData: libData })

export const clearPropCache = () => ({ type: 'CLEAR_PROP_CACHE'})

export const getPrebuiltScenes = (data) => ({
    type: 'GET_PREBUILT_SCENES',
    data
})

export const updateUserDetails = (data) => ({ type: "UPDATE_USER_DETAILS", data})

export const createFolder = (libData) => ({ type: "CREATE_LIBRARY_FOLDER", libData: libData })


export const setUserDetails = (data) => ({type : "SET_USER_DETAILS", data : data})

export const reqUpdate = (data) => ({type : "RESP_UPDATE", data : data})

export const clearDataCache = (data) => ({type : "CLEAR_DATA_CACHE", data : data})

export const clearActions = () => ({type : 'CLEAR_ACTIONS'})

export const isUploadInProcess = (data) => ({type : 'IS_UPLOAD_IN_PROCESS', data : data})



export const stopTour = (data) => ({type : 'STOP_TOUR', data})

export const startTour = (data) => ({type : 'START_TOUR', data})

export const openTourGuide = (data) => ({type : 'OPEN_TOUR_GUIDE', data})

export const suggestionPopup = (data) => ({type : 'SUGGESTION_POPUP', data})

export const nextBtnClicked = (data) => ({type : 'NEXT_BTN_CLICKED', data})

export const updateSuggestion = (data) => ({type : 'UPDATE_SUGGESTION', data})

export const updateTourId = (data) => ({type : 'UPDATE_TOUR_ID', data})

export const appLoaded = () => ({type : 'APP_LOADED'})

export const uploadedFile = (data) => ({type : 'UPLOADED_FILE', data})

export const startApp = (data) => ({type : 'START_APP', data})

export const suggPos = (data) => ({type : 'SUGG_POS', data})

export const setTourMenu = (data) => ({type : 'SET_TOUR_MENU', data})

export const updateUserActive = (data) => ({type : 'UPDATE_USER_ACTIVE', data})

export const fromMenu = (data) => ({type : 'FROM_TOUR', data})

export const addTourStep = (data) => ({type : 'ADD_TOUR_STEP', data})

export const addedUpload = (data) => ({type : 'ADDED_UPLOAD', data})

export const startToolTour = (data) => ({type : 'CHANGE_TOOL_TOUR', data})
export const fileToUpload = (data) => ({type : 'FILE_TO_UPLOAD', data})

export const itemToUpdate = (data) => ({type : 'ITEM_TO_UPDATE', data})

export const draggedFile = (data) => ({type : 'DRAGGED_FILE', data})

export const undoScenePaste = (data, socket) => ({type : 'UNDO_SCENE_PASTE', data, socket})

export const getActionSearchData = (libData) => ({ type: "FETCH_ACTION_SEARCH", libData })

export const libCurrentFolder = (data) => ({ type : 'LIB_CURRENT_FOLDER', data})

export const applyAllTransition = (data,socket) => ({ type: 'APPLY_ALL_TRANSITION' ,data,socket})
    
export const applyAllTransitionComplete = (projectid,transData,isUndo,sceneTransData ,socketId, currentSocketId) =>({ type: 'APPLY_ALL_TRANSITION_COMPLETE', projectid,transData,isUndo, sceneTransData, socketId, currentSocketId})

export const addLinkToText = (data , socket) =>({type:'ADD_LINK_TO_TEXT', data , socket})

export const addLinkToTextComplete = (projectid, selectedScene, container,selectedItem, hyperLinkData, socketId, currentSocketId) => ({type:'ADD_LINK_TO_TEXT_COMPLETE' , projectid, selectedScene, container,selectedItem, hyperLinkData, socketId, currentSocketId})
    
export const setPlayerPosition = (data) => ({type:'SET_PLAYER_POSITION' , data})  

export const addSlideLabelData = (data) => ({type:'ADD_SLIDELABEL_DATA' , data})  
 
export const setScenePosition = (data  , currentSceneNumber , currentSceneStartTime , currentSceneDuration) => ({type:'SET_SCENE_POSITION',data  , currentSceneNumber , currentSceneStartTime , currentSceneDuration})

export const removeScenePosition =() => ({type:'REMOVE_SCENE_POSITION'})

export const setAutoPlay = (data) => ({type:'SET_AUTO_PLAY' , data})

export const setPreview = (data) => ({type:'SET_PREVIEW',data})

export const setWorkspaceItemsOrder =(data , socket)=>({type:'SET_WORKSPACE_ITEMS_ORDER',data,socket})

export const setWorkspaceItemsOrderComplete = (projectId,selectedScene,container,workspaceItemsOrder,socketId,currentSocketId) => ({type:'SET_WORKSPACE_ITEMS_ORDER_COMPLETE',projectId,selectedScene,container,workspaceItemsOrder,socketId,currentSocketId})

export const setAnimateValue = (data , socket) => ({type:'SET_ANIMATE_VALUE',data,socket})

export const setAnimateValueComplete = (projectId,selectedScene,container,selectedItem,animateData,socketId,currentSocketId) =>({type:'SET_ANIMATE_VALUE_COMPLETE',projectId,selectedScene,container,selectedItem,animateData,socketId,currentSocketId})

export const setWorkspaceStage = (data)=>({type:'SET_WORKSPACE_STAGE',data})

export const setZoomFit = (data)=> ({type:'SET_ZOOM_FIT',data})

export const setApplyEffectSlides =(data) => ({
    type: 'SET_APPLYEFFECT_SLIDES',
    data
})

export const setLabelValues =(data) => ({
    type: 'SET_LABEL_VALUES',
    data
})
export const setNewActionComplete = (data) =>({type:'SET_NEW_ACTION_COMPLETE',data})

export const setTextWidth = (data,socket) => ({type:'SET_TEXT_WIDTH',data,socket})

export const addLinkToObj = (data , socket) =>({type:'ADD_LINK_TO_OBJ', data , socket})

export const addLinkToObjComplete = (projectid, selectedScene,selectedItem, linkData, socketId, currentSocketId) => ({type:'ADD_LINK_TO_OBJ_COMPLETE' , projectid, selectedScene,selectedItem,linkData, socketId, currentSocketId})

export const fireAppCrash = (errorId, error) => ({
    type: 'APP_CRASHED',
    errorData: {
        errorId,
        error
    }
})
export const projectRestore = (data,socket) => ({type:'PROJECT_RESTORE',data,socket})

export const setPaymentPastDue = (data,socket) => ({type:'SET_PAYMENT_PAST_DUE',data,socket})

export const setSlideJump=(data) => ({
    type: 'SET_SLIDE_JUMP',
    data
})

export const setIsShapeInGrp=(data) => ({
    type: 'SET_ISSHAPEINGRP',
    data
})

export const setIsTextClicked=(data) => ({
    type: 'SET_IS_TEXTCLICKED',
    data
})


// WEBPACK FOOTER //
// ./src/actions/index.js